import crossDanger from '@/assets/cross-danger.svg';
import crossSuccess from '@/assets/cross-success.svg';
import shieldCross from '@/assets/shield-cross.svg';
import shieldTicket from '@/assets/shield-tick.svg';
import { EBeep } from '@/components/HiddenSoundPlayer/types';
import { useEventBus } from '@/plugins/eventBus/eventBus';
// Basic browser-native HTML escaping to avoid Node.js dependency issues
const escapeHtml = (unsafe: string) => {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};
import { toast } from 'vue3-toastify';

export const showDefaultToast = (message: string, type: "success" | "error", autoCloseTime = 5000) => {
  const eventBus = useEventBus();
  
  message = escapeHtml(message)

  const imgSrc = type === "success" ? shieldTicket : shieldCross;
  const closeIconSrc = type === "success" ? crossSuccess : crossDanger; 
  const bodyClassName = type === "success" ? "success-toast" : "error-toast"

  const msg = `
    <div>
      <img src="${imgSrc}" alt="" width="35px" height="35px">
      <p>${message}</p>
    </div>
    <img src="${closeIconSrc}" alt="" width="27px" height="27px">
  `;

  if(type === "error") {
    eventBus.emit('play-audio', EBeep.ERROR);
  }

  toast(msg, {
    autoClose: autoCloseTime,
    theme: 'dark',
    type: 'default',
    position: 'top-center',
    hideProgressBar: true,
    closeButton: false,
    bodyClassName
  })
}

export const showSuccessToast = (message: string, autoClose: boolean = true) => {
  message = escapeHtml(message)

  toast(message, {
    autoClose: autoClose ? 5000 : undefined,
    theme: 'dark',
    type: 'success',
    position: 'bottom-center',
    hideProgressBar: true
  })
}